import { jsx as _jsx } from "react/jsx-runtime";
import { MarkdownBase } from '@/components';
import { useResolveValue } from '@/hooks';
import { convertToCSS } from '@/utils';
import { BlockLayout } from '../fragments/BlockLayout';
export const HeadingText = ({ block: { content, id, layout } }) => {
    const [resolver] = useResolveValue();
    const resolved = {
        content: resolver.resolveString(content)
    };
    const styles = Object.assign(Object.assign({}, convertToCSS(layout)), { fontSize: 'xl', fontWeight: 'semibold' });
    return (_jsx(BlockLayout, Object.assign({ layout: layout }, { children: _jsx(MarkdownBase, { "data-test": id, markdown: resolved.content, sx: styles }) })));
};
